<template>
  <main class="home">
    <header class="header">
      <img
        class="is-hidden-desktop img-banner"
        src="../assets/images/banners/cotizacion_mobile.svg"
        alt=""
      />
      <div
        class="header__content-wrap column  is-half-desktop is-offset-half-desktop"
      >
        <div class="header__content">
          <h2 class="color-primary mb-3">
            Agiliza el proceso de <br />
            convertir cotizaciones a ventas
          </h2>
          <p>
            Genera documentos profesionales en <br class="is-hidden-touch" />
            segundos para tus clientes. Aclara cualquier
            <br class="is-hidden-touch" />duda en el alcance solicitado por el
            cliente<br class="is-hidden-touch" />
            y facilita el proceso de venta.
          </p>
          <div class="header__actions">
            <a
              rel="noopenner noreferer"
              class="button is-rounded bg-primary"
              href="https://app.contafacil.pe/#!/registro"
              @click="emitGlobalTriggerGtag('prueba_gratis')"
              >Prueba Gratis</a
            >
            <a class="button is-rounded bg-disabled" @click="setVideoDemo"
              >Video Demo</a
            >
          </div>
        </div>
      </div>
    </header>
    <tab-modules></tab-modules>
    <section class="section no-padding--left no-padding--right">
      <div
        class="columns is-desktop section__video section__video--column my-5"
      >
        <h3 class="color-primary">
          Organiza los estados de tu negocio y <br class="is-hidden-touch" />
          monitorea su estado
        </h3>
        <div class="cotizacion-center">
          <img src="../assets/images/cotizacion_1.png" alt="" />
        </div>
        <!-- <h3 class="color-primary is-hidden-desktop">
          Organiza los estados de tu negocio y <br class="is-hidden-touch" />
          monitorea su estado
        </h3> -->
        <p class="text-principal text-center-section my-4">
          ContaFácil permite crear y organizar las cotizaciones emitidas<br
            class="is-hidden-touch"
          />
          desde tus puntos de venta. Una vez el cliente apruebe la<br
            class="is-hidden-touch"
          />
          cotización, ésta puede convertirse en una venta en tan solo<br
            class="is-hidden-touch"
          />
          unos pasos.
        </p>
        <a
          rel="noopenner noreferer"
          class="button is-rounded bg-primary"
          href="https://app.contafacil.pe/#!/registro"
          @click="emitGlobalTriggerGtag('prueba_gratis')"
          >Prueba Gratis</a
        >
      </div>
      <div class="columns is-desktop section__video no-padding--right">
        <div class="cotizacion column column-50 column-offset-10">
          <img class="mal" src="../assets/images/cotizacion_2.svg" alt="" />
        </div>
        <div class="video__text column is-two-fifths-desktop">
          <div class="text-wrap-aux">
            <h3 class="color-primary">
              Acelera el inicio <br class="is-hidden-touch" />
              de tus proyectos
            </h3>
            <p>
              No pierdas tiempo en escribir<br class="is-hidden-touch" />
              documentos extensos. ContaFácil<br class="is-hidden-touch" />
              permite generar documentos en<br class="is-hidden-touch" />
              segundos y darte tiempo para<br class="is-hidden-touch" />
              aclarar cualquier duda que surja<br class="is-hidden-touch" />
              con el cliente. Evita retrasos en la<br class="is-hidden-touch" />
              confirmación de la venta.
            </p>
            <a
              rel="noopenner noreferer"
              class="button button-ml-0 is-rounded bg-primary"
              href="https://app.contafacil.pe/#!/registro"
              @click="emitGlobalTriggerGtag('prueba_gratis')"
              >Prueba Gratis</a
            >
          </div>
        </div>
      </div>
      <div class="columns is-desktop section__video no-padding--left mar-top">
        <div class="cotizacion column column-50">
          <img
            src="../assets/images/cotizacion_3.png"
            alt=""
            class="img--left"
          />
        </div>
        <div
          class="video__text video__text--right column is-two-fifths-desktop-desktop"
        >
          <div class="text-wrap-aux">
            <h3 class="color-primary">
              Comparte documentos <br class="is-hidden-touch" />
              profesionales con tus clientes
            </h3>
            <p>
              Crea documentos personalizados<br class="is-hidden-touch" />
              con el logo de tu empresa.<br class="is-hidden-touch" />
              ContaFácil realiza el envío<br class="is-hidden-touch" />
              automático de la cotización por<br class="is-hidden-touch" />
              correo electrónico a tu cliente.
            </p>
            <a
              rel="noopenner noreferer"
              class="button button-mr-0 is-rounded bg-primary"
              href="https://app.contafacil.pe/#!/registro"
              @click="emitGlobalTriggerGtag('prueba_gratis')"
              >Prueba Gratis</a
            >
          </div>
        </div>
      </div>
    </section>
    <one-view></one-view>
  </main>
</template>

<script>
// @ is an alias to /src
import TabModules from "../components/TabModules";
import OneView from "../components/OneView";
import { EventBus } from "@/event-bus";

export default {
  name: "Cotizaciones",
  components: {
    TabModules,
    OneView
  },
  methods: {
    setVideoDemo() {
      EventBus.$emit("triggerGtag", "video_demo");
      this.$modal.show("video-demo", {
        src: `<iframe width="560" height="315" src="https://www.youtube.com/embed/DZY5pxemOIs" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`
      });
    },
    emitGlobalTriggerGtag(type) {
      EventBus.$emit("triggerGtag", type);
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../assets/styles/general.scss";
.header {
  // height: calc(100vh - 75px);
  // background-image: url("../assets/images/banners/cotizacion_mobile.svg");
  // background-repeat: no-repeat;
  // background-size: 100% auto;
  // background-attachment: local;
  // background-origin: border-box;
  &__content-wrap {
    justify-content: flex-end;
    padding-bottom: 18%;
  }
  &__content {
    background-color: transparent;
    margin-top: auto;
    // height: 70%;
    width: 100%;
    h2 {
      font-weight: bold;
    }
    p {
      width: 100%;
      margin-left: auto;
    }
  }
  @include tablet() {
    background-image: none;
    height: fit-content;
    // max-height: 600px;
    // padding: 4em 0;

    &__content {
      background-color: transparent;
      width: 100%;
      // padding: 1rem;
      p {
        width: 100%;
      }
    }
  }
  @media (min-width: 1024px) {
    height: calc(100vh - 100px);
    background-image: url("../assets/images/banners/Cotizacion.svg");
    background-repeat: no-repeat;
    background-size: 100% auto;
    background-attachment: local;
    background-origin: border-box;
    // max-height: 500px;
    &__content-wrap {
      // justify-content: center;
      padding-bottom: 0%;
    }
    &__content {
      background-color: transparent;
      height: 70%;
      width: 100%;
      p {
        width: 100%;
      }
    }
  }
  @media (min-width: 1200px) {
    height: calc(100vh - 100px);
    background-image: url("../assets/images/banners/Cotizacion.svg");
    background-repeat: no-repeat;
    background-size: 100% auto;
    background-attachment: local;
    background-origin: border-box;
    // max-height: 690px;
  }
  @media (min-width: 1400px) {
    height: calc(100vh - 100px);
    background-image: url("../assets/images/banners/Cotizacion.svg");
    background-repeat: no-repeat;
    background-size: 100% auto;
    background-attachment: local;
    background-origin: border-box;
    // max-height: 690px;
  }
  @media (min-width: 1800px) {
    height: calc(100vh - 100px);
    background-image: url("../assets/images/banners/Cotizacion.svg");
    background-repeat: no-repeat;
    background-size: 100% auto;
    background-attachment: local;
    background-origin: border-box;
    // max-height: 1230px;
  }
}
.section {
  padding-top: 0px;
  .button {
    // font-size: 16px;
    // font-weight: 500;
    width: fit-content;
  }
  h2 {
    font-weight: bold;
    font-size: 3rem;
  }
  &__video {
    width: 100%;
    margin: 1em auto;
    // min-height: 560px;
    // display: flex;
    // flex-flow: column nowrap;
    // justify-content: flex-start;
    // align-items: stretch;
    @include laptop() {
      display: flex;
      flex-flow: row nowrap;
      justify-content: flex-start;
      align-items: stretch;
      margin: 4em 0px;
    }
    @include desktop() {
      margin: 7em 0px;
    }
    .video__text {
      display: flex;
      flex-flow: column nowrap;
      justify-content: center;
      align-items: flex-start;
      // order: 2;
      &--right {
        align-items: flex-end;
      }
      h3 {
        letter-spacing: 0.075em;
        font-size: 16px;
        width: 100%;
        font-weight: bold;
        color: #00c3bd;
        margin: 2em auto;
      }
      p {
        width: 90%;
        font-size: 16px;
        letter-spacing: 0.025em;
        font-weight: 400;
        margin: 2em auto;
      }
      .button {
        margin: 1rem auto;
      }
      @include tablet() {
        text-align: center;
        display: flex;
        flex-flow: column nowrap;
        justify-content: center;
        align-items: flex-start;
        // margin: 2rem auto;
        &--right {
          text-align: center;
          align-items: flex-end;
        }
        h3 {
          letter-spacing: 0.05em;
          font-size: 1.5rem;
          width: 90%;
          font-weight: bold;
        }
        p {
          width: 90%;
          font-size: 1.5rem;
        }
        .button {
          max-width: 200px;
          font-size: 1.2rem;
          // margin: 1rem auto !important;
        }
      }
      @include laptop() {
        text-align: left;
        display: flex;
        flex-flow: column nowrap;
        justify-content: center;
        align-items: flex-start;
        order: 0;
        &--right {
          text-align: right;
          align-items: flex-end;
          order: 1;
        }
        h3 {
          letter-spacing: 0.075em;
          font-size: 1.3rem;
          width: 100%;
          font-weight: bold;
        }
        p {
          // width: 90%;
          width: 100%;
          font-size: 1.2rem;
          letter-spacing: 0.075em;
          font-weight: 400;
        }
        .button {
          // margin-left: 0px;
          width: fit-content;
          font-weight: bold;
          &-mr-0 {
            margin-right: 0;
          }
          &-ml-0 {
            margin-left: 0px;
          }
        }
      }
      @include desktop() {
        text-align: left;
        display: flex;
        flex-flow: column nowrap;
        justify-content: center;
        align-items: flex-start;
        &--right {
          text-align: right;
          align-items: flex-end;
        }
        h3 {
          letter-spacing: 0.075em;
          font-size: 1.4rem;
          width: 100%;
          font-weight: bold;
        }
        p {
          // width: 90%;
          font-size: 1.4rem;
          letter-spacing: 0.075em;
          font-weight: 400;
        }
        .button {
          // margin-left: 0px;
          width: fit-content;
          font-weight: bold;
          &-mr-0 {
            margin-right: 0;
          }
          &-ml-0 {
            margin-left: 0px;
          }
        }
      }
      @include desktop-medium() {
        text-align: left;
        display: flex;
        flex-flow: column nowrap;
        justify-content: center;
        align-items: flex-start;
        &--right {
          text-align: right;
          align-items: flex-end;
        }
        h3 {
          letter-spacing: 0.075em;
          font-size: 1.5rem;
          width: 100%;
          font-weight: bold;
        }
        p {
          // width: 90%;
          font-size: 1.5rem;
          letter-spacing: 0.075em;
          font-weight: 400;
        }
        .button {
          // margin-left: 0px;
          width: fit-content;
          font-weight: bold;
          &-mr-0 {
            margin-right: 0;
          }
          &-ml-0 {
            margin-left: 0px;
          }
        }
      }
      @include desktop-large() {
        text-align: left;
        display: flex;
        flex-flow: column nowrap;
        justify-content: center;
        align-items: flex-start;
        &--right {
          text-align: right;
          align-items: flex-end;
        }
        h3 {
          letter-spacing: 0.075em;
          font-size: 1.8rem;
          font-weight: bold;
        }
        p {
          font-size: 1.8rem;
          letter-spacing: 0.075em;
          font-weight: 400;
        }
        .button {
          width: fit-content;
          font-weight: bold;
          &-mr-0 {
            margin-right: 0;
          }
          &-ml-0 {
            margin-left: 0px;
          }
        }
      }
    }
    .video__player,
    .video-mini__player {
      order: 1;
      background-image: url("../assets/images/video-placeholder.png");
      background-repeat: no-repeat;
      background-size: 100%;
      background-position: center;
      @include laptop() {
        // order: 0;
      }
    }
    .cotizacion-center {
      position: relative;
      // height: 350px;
      max-width: 800px;
      width: 100%;
      margin: 2em 0;

      img {
        max-width: 700px;
        width: 100%;
        height: auto;
      }

      @include laptop() {
        margin: 3em 0 4em;
      }
      @include desktop() {
        max-width: none;
        img {
          max-width: 900px;
          width: 100%;
        }
      }
      @include desktop-medium() {
        img {
          max-width: 1000px;
          width: 100%;
        }
      }
      @include desktop-large() {
        img {
          max-width: 1400px;
          width: 60%;
        }
      }
    }
    .text-center-section {
      width: 100%;
      // font-size: 16px;
      margin: 1rem auto;
      @include tablet() {
        // font-size: 1.2rem;
        width: 75%;
      }
    }
    .cotizacion {
      width: 100%;
      // display: flex;
      padding: 0px;
      order: 1;
      img {
        max-width: 700px;
        width: 100%;
        height: auto;
      }
      @include tablet() {
        img {
          max-width: none;
          object-fit: contain;
        }
      }
      @include laptop() {
        img {
          max-width: none;
          width: 100%;
        }
      }
    }
    .video-mini__player {
      height: 300px;
    }
    .video-mini__text {
      margin: 0 auto;
      margin-top: 3rem;
      width: 75%;
      h3 {
        letter-spacing: 0.075em;
        font-size: 2.55rem;
        width: 100%;
        font-weight: bold;
        color: #00c3bd;
      }
      p {
        width: 90%;
        font-size: 2.4rem;
        letter-spacing: 0.075em;
        font-weight: 400;
      }
    }
    &:first-child {
      padding-top: 0px;
    }
    &--column {
      width: 100%;
      // margin: 0 auto;
      flex-flow: column nowrap !important;
      justify-content: flex-start;
      align-items: center;
      h3 {
        font-weight: bold;
        font-size: 1rem;
        margin: 1em auto;
        color: #00c3bd;
      }
      p {
        font-size: 16px;
        letter-spacing: 0.025em;
      }
      .video__player {
        width: 100%;
        height: 500px;
      }
      @include tablet() {
        width: 100%;

        h3 {
          letter-spacing: 0.05em;
          font-size: 1.5rem;
          width: 90%;
          font-weight: bold;
        }
        p {
          font-size: 1.5rem;
          letter-spacing: 0.025em;
          width: 90%;
        }
        .button {
          font-size: 1.2rem;
          // max-width: 200px;
        }
      }
      @media (min-width: 1024px) {
        width: 100%;

        h3 {
          letter-spacing: 0.05em;
          font-size: 1.4rem;
          font-weight: bold;
        }
        p {
          font-size: 1.4rem;
          letter-spacing: 0.025em;
        }
        .button {
          // max-width: 200px;
        }
      }
      @include desktop() {
        width: 100%;

        h3 {
          letter-spacing: 0.05em;
          font-size: 1.4rem;
          font-weight: bold;
        }
        p {
          font-size: 1.4rem;
          letter-spacing: 0.025em;
        }
        .button {
          // max-width: 200px;
        }
      }
      @include desktop-medium() {
        width: 100%;

        h3 {
          letter-spacing: 0.05em;
          font-size: 1.5rem;
          font-weight: bold;
        }
        p {
          font-size: 1.5rem;
          letter-spacing: 0.025em;
        }
        .button {
          // max-width: 200px;
        }
      }
      @media (min-width: 1800px) {
        h3 {
          letter-spacing: 0.05em;
          font-size: 1.8rem;
          font-weight: bold;
        }
        p {
          font-size: 1.8rem;
          letter-spacing: 0.025em;
        }
        .button {
          font-size: 1.2rem;
          // max-width: 200px;
        }
      }
    }
    @include laptop() {
      // margin: 4rem auto !important;
    }
  }
}
.factura-img {
  display: block;
  width: 500px;
  margin: 4rem auto;
}
.text-principal {
  font-size: 2.3rem;
  width: 60%;
  // margin-top: 3rem;
  font-weight: 400;
}
</style>
